import React from 'react';
import { withRouter } from "react-router-dom";
import { FormComponent } from '../../../components/form/DynamicForm';
import { Form, Validators } from '../../../components/form/DynamicFormTs';
import Http from '../../../Http';

class Entregada extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'entrega/one', saveUrl: '', backUrl: '' },
      new Form([
        Form.Field('date-hour', 'g_fecha_entrega', 'Fecha', new Date(), [Validators.required], 8, [], [], [], false, true, false),
        Form.Field('radio', 'recibido', 'Recibido', '0', [Validators.required], 4, [
          { Label: 'No', Value: 0 },
        ]),
        Form.Field('select', 'g_tipo_entrega', 'Tipo de entrega', 'Incompleta', [Validators.required], 12, [
          { Value: 'Incompleta', Label: 'Incompleta' },
        ]),
        Form.Field('select', 'g_entrega_observacion', 'Motivo', '', [], 12),
      ], ['Guardar'], 'Registrar No Entrega'), this.formData
    )
    // if (this.props.match.params.id)
  }

  formData = async (form) => {
    let Res = await Http.get(`rechazo-motivo/all`);
    let newForm = form
    let motivos = [];
    if (!Res.error) {
      newForm = Form.FieldOptions(newForm, 'g_entrega_observacion', Res.data, 'id', 'rechazo_motivo_nombre');
      motivos = Res.data
    }
    newForm = Form.ValueChange(form, {
      recibido: this.recibidoChange
    })
    this.setState({ motivos })
    return newForm
  }

  recibidoChange = (val) => {
    const { Value } = val;
    let formData = this.state.FormData; 
    let hide = Value === "1" ? false : true;
    formData = Form.FieldMod(formData, 'g_tipo_entrega', 'Disabled', hide);
    formData = Form.FieldMod(formData, 'g_entrega_observacion', 'Type', 
    hide  ? 'select' : 'text');

    this.setState({ FormData: formData })
  }

  onSubmit = async (i, vals) => {
    try {
      const { motivos } = this.state
      this.setState({ loading: true });

      if (vals.recibido === '0') {
        const motivo = motivos.find(mot => `${mot.id}` === `${vals.g_entrega_observacion}`)
        if (motivo) {
          vals.g_entrega_observacion = motivo.rechazo_motivo_nombre
        }
      }

      let form = new FormData();
      form.append('g_fecha_entrega', vals.g_fecha_entrega);
      form.append('recibido', vals.recibido);
      form.append('g_tipo_entrega', vals.g_tipo_entrega);
      form.append('g_entrega_observacion', vals.g_entrega_observacion);

      let Res = await Http.post(`guia/${this.props.guiaId}/entregar`, form);
      // console.log(Res)
      if (!Res.error) {
        this.props.onSave();
        this.setState({ loading: false, sbMsg: `Guardado`, sbOpen: true });
      } else {
        this.setState({ loading: false, sbMsg: `Error al guardar${(Res.errMsg ? `: ${Res.errMsg}` : '')}`, sbOpen: true });
      }
    } catch (error) {
      console.log(error)
      this.setState({ loading: false, sbMsg: `Error al guardar`, sbOpen: true });
    }
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Entregada)
